<template>
  <div>
    <FormComponent
      @searchForm="getData"
      :searchFormItem="formItem"
      :labelWidth="120"
    >
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem label="潜能评分">
          <Select v-model="formItem.f">
            <Option
              v-for="item in selectList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
      </Col>
    </FormComponent>
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      style="margin:20px 0"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
    </Table>
    <div
      style="margin:20px 0;display:flex; justify-content: flex-end;flex-direction: column; align-items: flex-end;"
    >
      <Page :total="total" @on-change="pageChange" />
      <div>
        <Button type="primary" style="margin-top:15px">导入</Button>
        <Button type="primary" style="margin-top:15px"><!-- 导出 -->{{$t('PB_Export')}}</Button>
      </div>
    </div>

    <div class="chartBox">
      <RadioGroup v-model="radioValue">
        <Radio label="0" :value="true">人员占比</Radio>
        <Radio label="1">人员数据</Radio>
      </RadioGroup>
      <div class="chartCol1" v-if="radioValue == 0">
        <Row class="patentialRow">
          <Col span="3"><span>纵向潜能</span></Col>
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground1"
              @click="showInfoClick(10)"
            >
              10
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground1"
              @click="showInfoClick(16)"
            >
              16
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground2"
              @click="showInfoClick(8)"
            >
              8
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground2"
              @click="showInfoClick(22)"
            >
              22
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground2"
              @click="showInfoClick(6)"
            >
              6
            </div></Col
          >
        </Row>
        <Row class="patentialRow">
          <Col span="3"><span>横向潜能</span></Col>
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground1"
              @click="showInfoClick(3)"
            >
              3
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground1"
              @click="showInfoClick(11)"
            >
              11
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground3"
              @click="showInfoClick(26)"
            >
              26
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground3"
              @click="showInfoClick(16)"
            >
              16
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground3"
              @click="showInfoClick(33)"
            >
              33
            </div></Col
          >
        </Row>
        <Row class="patentialRow">
          <Col span="3"><span>本岗位发展</span></Col>
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground4"
              @click="showInfoClick(5)"
            >
              5
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground4"
              @click="showInfoClick(16)"
            >
              16
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground5"
              @click="showInfoClick(36)"
            >
              36
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground5"
              @click="showInfoClick(48)"
            >
              48
            </div></Col
          >
          <Col span="4"
            ><div
              class="potentialBox potentialBoxBackground5"
              @click="showInfoClick(22)"
            >
              22
            </div></Col
          >
        </Row>
        <Row class="patentialRow">
          <Col span="3"></Col>
          <Col span="4">需要改善 1分</Col>
          <Col span="4">部分达标 2分</Col>
          <Col span="4">达到要求 3分</Col>
          <Col span="4">超越要求 4分</Col>
          <Col span="4">优秀出色 5分</Col>
        </Row>
      </div>
      <Modal v-model="showinfoModal" title="员工信息" width="400px">
        <div class="modalListBox">
          <List header="员工姓名" border size="small">
            <ListItem v-for="(item, index) in dataListName" :key="index">
              <ListItemMeta>
                <template slot="title">
                  <div style="display:flex;align-items:center">
                    {{ item.cName
                    }}<Icon
                      v-if="
                        item.serialnumber == '0001' ||
                          item.serialnumber == '1002'
                      "
                      type="md-star"
                      size="12"
                      color="#ffb400"
                    />
                  </div>
                </template>
              </ListItemMeta>
              <template slot="action">
                <li><a href="javascript:;">更多</a></li>
              </template>
            </ListItem>
          </List>
        </div>
        <Spin size="large" fix v-if="modalSpinShow"></Spin>
        <div slot="footer">
          <Button @click="showinfoModal = false">关闭</Button>
        </div>
      </Modal>
      <Spin size="large" fix v-if="spinShow"></Spin>
      <AchAssessComponentCell v-if="radioValue == 1"></AchAssessComponentCell>
    </div>
  </div>
</template>

<script>
import FormComponent from "./FormComponent.vue";
import AchAssessComponentCell from "./AchAssessComponentCell.vue";
import axios from "axios";
export default {
  components: { FormComponent, AchAssessComponentCell },
  data() {
    return {
      loading: false,
      spinShow: false,
      modalSpinShow: false,
      totalNum: 0, //table数据总条数
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10 //每页数据条数
      },
      prevent: false,
      formItem: {},
      selectList: [],
      loading: false,
      total: 0,
      radioValue: "0",
      columns: [
        {
          title: "查看",
          slot: "action",
          align: "center",
          minWidth: 100
        },
        {
          title: "业务单元",
          key: "name",
          align: "center",
          minWidth: 120
        },
        {
          title: "部门",
          key: "code",
          align: "center",
          minWidth: 120
        },
        {
          title: "员工号",
          key: "year",
          align: "center",
          minWidth: 120
        },
        {
          title: "中文姓名",
          key: "month",
          align: "center",
          minWidth: 120
        },
        {
          title: "英文姓名",
          key: "month",
          align: "center",
          minWidth: 120
        },
        {
          title: "职位",
          key: "month",
          align: "center",
          minWidth: 120
        },
        {
          title: "直线经理",
          key: "month",
          align: "center",
          minWidth: 120
        },
        {
          title: "年度",
          key: "month",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t('PB_Resign_Date'),/* 离职日期 */
          key: "month",
          align: "center",
          minWidth: 120
        },
        {
          title: "潜能评分",
          key: "month",
          align: "center",
          minWidth: 120
        }
      ],
      data: [{ name: "业务单元" }],
      showinfoModal: false,
      dataListName: []
    };
  },
  created() {},
  methods: {
    showInfoClick(num) {
      this.dataListName = [];
      let obj = {
        empCode: "",
        chName: "",
        pageNo: 1,
        pageSize: num
      };
      this.showinfoModal = true;
      this.modalSpinShow = true;
      axios.post("/userListRole/selectUserListColumnSetData", obj).then(res => {
        if (res) {
          this.dataListName = res.tableData.data.data;
          this.modalSpinShow = false;
          console.log(this.dataListName);
        }
      });
    },
    getData() {},
    openPop(row) {},
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    }
  }
};
</script>

<style lang="less" scoped>
.chartBox {
  display: flex;
  flex-direction: column;
  .chartCol {
    width: 48%;
    margin-right: 2%;
    height: 600px;
    box-sizing: border-box;
  }
  .chartCol1 {
    padding-top: 30px;
    width: 100%;
    height: 600px;
    box-sizing: border-box;
  }
}
@media screen and (max-width: 1440px) {
  .chartBox {
    display: flex;
    flex-wrap: wrap;
    .chartCol {
      width: 100%;
      margin-right: 0;
      height: 420px;
      box-sizing: border-box;
    }
    .chartCol1 {
      width: 100%;
      height: 420px;
      box-sizing: border-box;
    }
  }
}
.chartTit {
  font-size: 20px;
  font-weight: bold;
  color: #4ea397;
  text-align: center;
  margin: 0px 0 30px 0;
}
.patentialRow {
  margin-top: 8px;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  span {
    display: block;
    text-align: right;
    margin-right: 20px;
  }
}

.potentialBox {
  width: 96%;
  height: 120px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  line-height: 120px;
  text-align: center;
  cursor: pointer;
  font-size: 22px;
}
.potentialBox:hover {
  opacity: 0.5;
}
.potentialBoxBackground1 {
  background-image: linear-gradient(
    45deg,
    #dfdfdf 25%,
    white 0,
    white 50%,
    #dfdfdf 0,
    #dfdfdf 75%,
    white 0
  );
  background-size: 6px 6px;
}
.potentialBoxBackground2 {
  background-color: rgb(0, 50, 30);
  color: white;
}
.potentialBoxBackground3 {
  background-color: rgb(23, 177, 105);
}
.potentialBoxBackground4 {
  background-color: rgb(255, 180, 0);
}
.potentialBoxBackground5 {
  background-color: rgb(180, 145, 50);
}
.modalListBox {
  max-height: 500px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/PotentialAssessment.vue